import { render, staticRenderFns } from "./dish-edit.vue?vue&type=template&id=1d79441e&scoped=true&"
import script from "./dish-edit.vue?vue&type=script&lang=js&"
export * from "./dish-edit.vue?vue&type=script&lang=js&"
import style0 from "./dish-edit.vue?vue&type=style&index=0&id=1d79441e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79441e",
  null
  
)

export default component.exports